import { BsList, BsBell, BsBellFill, BsFillEyeSlashFill, BsFillEyeFill, BsX, BsFillGiftFill, BsFillPeopleFill, BsArrowRightCircleFill, BsArrowDownCircleFill, BsPeople, BsArrowUpCircleFill, BsShare, BsBank2, BsChevronLeft, BsCreditCard2Back, BsFillShareFill, BsPenFill, BsDownload, BsMoonFill, BsSunFill, BsFacebook, BsTwitter, BsInstagram, BsLinkedin, BsChatLeftTextFill, BsFillPersonFill, BsFillKeyFill, BsFillLockFill, BsTelegram, BsWhatsapp, BsShieldLockFill, BsCartFill, BsBasket, BsChevronUp, BsChevronDown, BsFillCreditCard2BackFill, BsReceipt, BsEmojiFrown, BsCashCoin, BsBoxSeam, BsFilePlusFill, BsFileMinusFill, BsHouseUp, BsGraphUpArrow, BsBox2, BsGraphDownArrow, BsBag, BsArrowUp, BsArrowDown, } from 'react-icons/bs';
import { IoCheckmark, IoCheckmarkCircleSharp, IoCopy, IoFlashSharp, IoLogOut, IoMailUnread, IoPaperPlane, IoSend } from 'react-icons/io5';
import { IoIosTimer, IoMdArrowDown, IoMdArrowForward, IoMdArrowUp } from "react-icons/io";
import { MdManageSearch, MdAlternateEmail, MdCameraswitch, MdQrCodeScanner, MdVerified, MdOutlineHomeRepairService } from "react-icons/md";
import { FaArrowRight, FaLink, FaMoneyBill, FaPeopleArrows, FaSlackHash, FaWallet } from "react-icons/fa";
import { AiFillDashboard, AiFillExclamationCircle, AiFillSetting, AiOutlinePaperClip, AiOutlineQrcode } from "react-icons/ai";
import { CgData } from "react-icons/cg";
import { BiBarChartAlt, BiDotsVertical, BiHome, BiLogoMastercard, BiLogoVisa, BiSupport } from "react-icons/bi";
import { SiGmail } from "react-icons/si";
import { GiCheckMark, GiCrossMark, GiPayMoney, GiReceiveMoney } from "react-icons/gi";
import { GoUnverified } from "react-icons/go";
import { ImBin } from "react-icons/im";
import { LiaClipboardListSolid, LiaCoinsSolid } from "react-icons/lia";
import { PiMapPinLight, PiUserCircleLight } from "react-icons/pi";

import { HiMiniArrowPath } from "react-icons/hi2";


const ICON_PLUS = <BsFilePlusFill />;
const ICON_MINUS = <BsFileMinusFill />;
const ICON_MARK = <IoCheckmark />;
const ICON_MARK_STYLE = <GiCheckMark />;
const ICON_MARK_FILL = <IoCheckmarkCircleSharp />;
const ICON_LIST = <BsList />;
const ICON_BELL = <BsBell />;
const ICON_BELL_FILL = <BsBellFill />;
const ICON_PLANE = <IoPaperPlane />;
const ICON_EYE_FILL = <BsFillEyeFill />;
const ICON_EYE_SLASH_FILL = <BsFillEyeSlashFill />;
const ICON_SEARCH = <MdManageSearch />;
const ICON_X = <BsX />;
const ICON_X_STYLE = <GiCrossMark />;
const ICON_GIFT_FILL = <BsFillGiftFill />;
const ICON_PEOPLE_FILL = <BsFillPeopleFill />;
const ICON_PEOPLE = <BsPeople />;
const ICON_MONEY_BILL = <FaMoneyBill />;
const ICON_PEOPLE_ARROW = <FaPeopleArrows />;
const ICON_WALLET = <FaWallet />;
const ICON_DASHBOARD = <AiFillDashboard />;

const ICON_ARROW_UP = <IoMdArrowUp />;
const ICON_ARROW_DOWN = <IoMdArrowDown />;
const ICON_ARROW_RIGHT_CIRCLE = <BsArrowRightCircleFill />;
const ICON_ARROW_DOWN_CIRCLE = <BsArrowDownCircleFill />;
const ICON_ARROW_UP_CIRCLE = <BsArrowUpCircleFill />;
const ICON_ARROW_LEFT = <BsChevronLeft />;
const ICON_CHEVRON_DOWN = <BsChevronUp />;
const ICON_CHEVRON_UP = <BsChevronDown />;
const ICON_ARROW_RIGHT = <IoMdArrowForward />;

const ICON_DATA = <CgData />;
const ICON_SHARE = <BsShare />;
const ICON_SAVE = <BsDownload />;
const ICON_SHARE_FILL = <BsFillShareFill />;
const ICON_EXCLAMATION = <AiFillExclamationCircle />;
const ICON_BANK = <BsBank2 />;
const ICON_AT = <MdAlternateEmail />;
const ICON_QR = <AiOutlineQrcode />;
const ICON_CARD = <BsCreditCard2Back />;
const ICON_PEN = <BsPenFill />;
const ICON_HASH = <FaSlackHash />;
const ICON_COPY = <IoCopy />;
const ICON_LOGOUT = <IoLogOut />;
const ICON_SWITCH_CAMERA = <MdCameraswitch />;
const ICON_SCAN = <MdQrCodeScanner />;
const ICON_RECEIVE_MONEY = <GiReceiveMoney />;
const ICON_PAY_MONEY = <GiPayMoney />;
const ICON_SEND = <IoSend />;
const ICON_PAPER_CLIP = <AiOutlinePaperClip />;
const ICON_MOON = <BsMoonFill />;
const ICON_SUN = <BsSunFill />;
const ICON_FACEBOOK = <BsFacebook />;
const ICON_TWITTER = <BsTwitter />;
const ICON_INSTAGRAM = <BsInstagram />;
const ICON_LINKEDIN = <BsLinkedin />;
const ICON_TELEGRAM = <BsTelegram />;
const ICON_EMAIL = <IoMailUnread />;
const ICON_GMAIL = <SiGmail />;
const ICON_WHATSAPP = <BsWhatsapp />;
const ICON_CHAT = <BsChatLeftTextFill />;
const ICON_LINK = <FaLink />;
const ICON_FLASH = <IoFlashSharp />;
const ICON_USER = <BsFillPersonFill />;
const ICON_KEY = <BsFillKeyFill />;
const ICON_BIN = <ImBin />;
const ICON_LOCK = <BsFillLockFill />;
const ICON_VERIFIED = <MdVerified />;
const ICON_UNVERIFIED = <GoUnverified />;
const ICON_SETTING = <AiFillSetting />;

const ICON_SHIELD = <BsShieldLockFill />;
const ICON_SUPPORT = <BiSupport />;
const ICON_CART = <BsCartFill />;
const ICON_BASKET = <BsBasket />;

const ICON_CREDIT_CARD = <BsFillCreditCard2BackFill />;
const ICON_VISA = <BiLogoVisa />;
const ICON_MASTERCARD = <BiLogoMastercard />;
const ICON_RECEIPT = <BsReceipt />;
const ICON_HOME = <BiHome />;
const ICON_OPTION = <BiDotsVertical />;

const ICON_FROWN = <BsEmojiFrown />;
const ICON_CASH_COIN = <BsCashCoin />;
const ICON_BOX_SEAM = <BsBoxSeam />;

const ICON_SALES = <LiaCoinsSolid />;
const ICON_REVENUE = <BiBarChartAlt />;
const ICON_PROFIT = <BsGraphUpArrow />;
const ICON_COST = <BsHouseUp />;
const ICON_QIH = <BsBox2 />;
const ICON_TBR = <PiMapPinLight />;
const ICON_LQS = <BsGraphDownArrow />;
const ICON_NOS = <PiUserCircleLight />;
const ICON_NOC = <LiaClipboardListSolid />;
const ICON_NOSER = <MdOutlineHomeRepairService />;
const ICON_EXPIRE = <IoIosTimer />;
const ICON_TOP_SELLING = <BsGraphUpArrow />;
const ICON_PRODUCT = <BsBag />;
const ICON_RELOAD = <HiMiniArrowPath />;


export {
    ICON_PLUS,
    ICON_MINUS,
    ICON_MARK,
    ICON_MARK_STYLE,
    ICON_MARK_FILL,
    ICON_BELL,
    ICON_BELL_FILL,
    ICON_LIST,
    ICON_PLANE,
    ICON_EYE_FILL,
    ICON_EYE_SLASH_FILL,
    ICON_SEARCH,
    ICON_X,
    ICON_X_STYLE,
    ICON_GIFT_FILL,
    ICON_PEOPLE_FILL,
    ICON_PEOPLE,
    ICON_MONEY_BILL,
    ICON_PEOPLE_ARROW,
    ICON_WALLET,
    ICON_DASHBOARD,
    ICON_ARROW_UP,
    ICON_ARROW_DOWN,
    ICON_ARROW_RIGHT_CIRCLE,
    ICON_ARROW_DOWN_CIRCLE,
    ICON_ARROW_UP_CIRCLE,
    ICON_ARROW_LEFT,
    ICON_DATA,
    ICON_SHARE,
    ICON_SAVE,
    ICON_SHARE_FILL,
    ICON_EXCLAMATION,
    ICON_BANK,
    ICON_AT,
    ICON_QR,
    ICON_CARD,
    ICON_HASH,
    ICON_COPY,
    ICON_LOGOUT,
    ICON_PEN,
    ICON_SWITCH_CAMERA,
    ICON_SCAN,
    ICON_RECEIVE_MONEY,
    ICON_PAY_MONEY,
    ICON_SEND,
    ICON_PAPER_CLIP,
    ICON_MOON,
    ICON_SUN,
    ICON_FACEBOOK,
    ICON_INSTAGRAM, ICON_LINKEDIN, ICON_TWITTER, ICON_EMAIL, ICON_TELEGRAM, ICON_GMAIL, ICON_WHATSAPP,
    ICON_ARROW_RIGHT,
    ICON_CHAT,
    ICON_LINK,
    ICON_FLASH,
    ICON_USER,
    ICON_KEY,
    ICON_BIN,
    ICON_LOCK,
    ICON_VERIFIED,
    ICON_UNVERIFIED,
    ICON_SETTING,
    ICON_SUPPORT,
    ICON_SHIELD,
    ICON_CART,
    ICON_BASKET,
    ICON_CHEVRON_DOWN,
    ICON_CHEVRON_UP,
    ICON_CREDIT_CARD,
    ICON_MASTERCARD,
    ICON_VISA,
    ICON_RECEIPT,
    ICON_HOME,
    ICON_OPTION,
    ICON_FROWN,
    ICON_CASH_COIN,
    ICON_BOX_SEAM,

    ICON_SALES,
    ICON_PROFIT,
    ICON_REVENUE,
    ICON_COST,
    ICON_QIH,
    ICON_TBR,
    ICON_LQS,
    ICON_NOS,
    ICON_NOC,
    ICON_NOSER,
    ICON_EXPIRE,
    ICON_TOP_SELLING,
    ICON_PRODUCT,
    ICON_RELOAD

};